import { Box, Modal, Fade } from '@mui/material';
import { styles } from '../assets/styles';

export default function InputBox({ children }) {
  return (
    <Box sx={styles.pokeBox1}>
      <Box sx={styles.pokeBox2}>
        <Box sx={styles.pokeBox3}>
          <Box sx={styles.pokeBox4}>
            <Box sx={styles.pokeBox5}>{children}</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export function WinnerBox({ children, gifRef }) {
  return (
    <div ref={gifRef} className="fade-in-4" style={styles.pokeboxGuess1}>
      <div style={styles.pokeboxGuess2}>
        <div style={styles.pokeboxGuess3}>
          <div style={styles.pokeboxGuess4}>
            <div style={styles.pokeboxGuess5}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ShareBox({ children }) {
  return (
    <div style={styles.pokeBoxShare1}>
      <div style={styles.pokeBoxShare2}>
        <div style={styles.pokeBoxShare3}>
          <div style={styles.pokeBoxShare4}>
            <div style={styles.pokeBoxShare5}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ModalBox({ children, open2, handleClose2 }) {
  return (
    <Modal open={open2} onClose={handleClose2} sx={styles.modalOpenHowTo}>
      <Fade in={open2}>
        <Box sx={styles.howToBox1}>
          <Box sx={styles.howToBox2}>
            <Box sx={styles.howToBox3}>{children}</Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
